import * as React from 'react';
import { Navigate } from 'react-router-dom';

import * as authRequest from '../utils/requests/authRequest';

const authContext = React.createContext();

function useAuth() {
  const [authed, setAuthed] = React.useState(false);

  return {
    authed,
    login() {
      return new Promise((res) => {
        authRequest
          .checkLogin()
          .then((result) => {
            setAuthed(result);
            res();
          })
          .catch((e) => {
            setAuthed(false);
            res();
          });
      });
    },
    logout() {
      return new Promise((res) => {
        setAuthed(false);
        res();
      });
    }
  };
}

export function AuthProvider({ children }) {
  const auth = useAuth();

  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export function RequireAuth({ children }) {
  const result = authRequest.isLogin();
  return result === true ? children : <Navigate to="/login" replace />;
}

export default function AuthConsumer() {
  return React.useContext(authContext);
}
